import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import HomePage from "./pages/HomePage";
import LeCentrePage from "./pages/LeCentrePage";
import PrestationsPage from "./pages/PrestationsPage";
import VoituresPage from "./pages/vehicules/VoituresPage";
import MotosPage from "./pages/vehicules/MotosPage";
import CollectionPage from "./pages/vehicules/CollectionPage";
import UtilitairesPage from "./pages/vehicules/UtilitairesPage";
import CityLandingPage from "./pages/CityLandingPage";
import PasCher93Page from "./pages/PasCher93Page";
import ControleTechniqueMoto93Page from "./pages/ControleTechniqueMoto93Page";

import ContactPage from "./pages/ContactPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import PolitiqueCookiesPage from "./pages/PolitiqueCookiesPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";
import BlogPage from "./pages/BlogPage";
import ArticlePage from "./pages/ArticlePage";
import TagPage from "./pages/TagPage";
import FAQPage from "./pages/FAQPage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/le-centre" element={<LeCentrePage />} />
          <Route path="/prestations" element={<PrestationsPage />} />
          <Route path="/vehicules/voitures" element={<VoituresPage />} />
          <Route path="/vehicules/motos" element={<MotosPage />} />
          <Route path="/vehicules/collection" element={<CollectionPage />} />
          <Route path="/vehicules/utilitaires" element={<UtilitairesPage />} />
          
          {/* SEO Landing pages */}
          <Route path="/controle-technique-pas-cher-93" element={<PasCher93Page />} />
          <Route path="/controle-technique-moto-93" element={<ControleTechniqueMoto93Page />} />
          <Route path="/:citySlug" element={<CityLandingPage />} />

          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/politique-cookies" element={<PolitiqueCookiesPage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/blog/tag/:tag" element={<TagPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
